import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { StoryCard, MapCard, CardDb } from '../redux/cardDbSlice';
import useOneSheetValue from './useOneSheetValue';

const useAllCardDbsInSheet = (sheetId: string | null) : [string[], CardDb[]] => {
  const cardDb = useSelector((state: RootState) => state.cardDb);
  const ids = Object.keys(cardDb.cards).filter(id => cardDb.cards[id].sheetId === sheetId);
  const sheetKind = useOneSheetValue(sheetId)?.sheetKind;
  if (sheetKind === 'story') {
    ids.sort((a, b) => {
      const cardA = cardDb.cards[a] as StoryCard;
      const cardB = cardDb.cards[b] as StoryCard;
      return cardA.order - cardB.order;
    })
  } else if (sheetKind === 'map') {
    ids.sort((a, b) => {
      const cardA = cardDb.cards[a] as MapCard;
      const cardB = cardDb.cards[b] as MapCard;
      if (cardA.isGroup && !cardB.isGroup) return -1;
      else if (!cardA.isGroup && cardB.isGroup) return 1;
      else return cardA.z - cardB.z;
    })
  }

  const values = ids.map(id => cardDb.cards[id]);

  return [ids, values];
}

export default useAllCardDbsInSheet;
